<template>
  <div class="fathers-day">
    <div class="bg-container">
      <bushes class="bushes-svg"></bushes>
      <grass class="grass-svg"></grass>
      <father-cub class="father-cub-svg"></father-cub>
    </div>

    <father-names class="father-names"
                  :name1="`${$store.getters.activeSlide.fathers[0] ? $store.getters.activeSlide.fathers[0].firstname : ''} ${$store.getters.activeSlide.fathers[0] ? $store.getters.activeSlide.fathers[0].lastname : ''}`"
                  :name2="`${$store.getters.activeSlide.fathers[1] ? $store.getters.activeSlide.fathers[1].firstname : ''} ${$store.getters.activeSlide.fathers[1] ? $store.getters.activeSlide.fathers[1].lastname : ''}`"
                  :name3="`${$store.getters.activeSlide.fathers[2] ? $store.getters.activeSlide.fathers[2].firstname : ''} ${$store.getters.activeSlide.fathers[2] ? $store.getters.activeSlide.fathers[2].lastname : ''}`"></father-names>

    <div class="heading">
      <div class="heading-line heading-line-1">HAPPY FATHER'S DAY</div>
      <div class="heading-line heading-line-2">celebrating your unconditional</div>
      <div class="heading-line heading-line-3">
        L<span class="spacer"></span>VE
        <img class="heart" src="@/assets/images/fathers/heart.svg">
      </div>
    </div>

    <img class="labour-love" src="@/assets/images/labour-love-4.svg">

  </div>
</template>

<script>
import { TweenMax, TimelineMax, Power0, Power1, Power4, Back } from 'gsap/TweenMax'
import SplitText from '@/assets/gsap-bonus/SplitText'
import Bushes from '@/components/FathersSlide/Bushes.vue'
import FatherCub from '@/components/FathersSlide/FatherCub.vue'
import Grass from '@/components/FathersSlide/Grass.vue'
import FatherNames from '@/components/FathersSlide/FatherNames.vue'

export default {
  name: 'FathersDaySlide',

  components: { Bushes, FatherCub, Grass, FatherNames },

  data () {
    return {
      tl: new TimelineMax(),
      tlEyes: new TimelineMax({ repeat: -1, repeatDelay: 3 }),
      tlBloom: new TimelineMax({ repeat: -1, repeatDelay: 3 })
    }
  },
  mounted () {
    // Copies
    const headingLines = this.$el.querySelectorAll('.heading-line')
    const heading1 = this.$el.querySelector('.heading-line-1')
    const heading2 = this.$el.querySelector('.heading-line-2')
    const headingSplit1 = new SplitText(heading1, { type: 'words' })
    const headingSplit2 = new SplitText(heading2, { type: 'chars' })
    const heart = this.$el.querySelector('.heart')

    // Svg
    const dadCub = this.$el.querySelector('.dad-cub')
    const dadEyelids = this.$el.querySelectorAll('.dad-eyelid')
    const dadBrow1 = this.$el.querySelector('.dad-brow-1')
    const dadBrow2 = this.$el.querySelector('.dad-brow-2')
    const cubEyes = this.$el.querySelectorAll('.cub-eye')
    const cubBrow1 = this.$el.querySelector('.cub-brow-1')
    const cubBrow2 = this.$el.querySelector('.cub-brow-2')
    const dadMouth = this.$el.querySelector('.dad-mouth')
    const dadArm1 = this.$el.querySelector('.dad-arm-1')
    const dadArm2 = this.$el.querySelectorAll('.dad-arm-2')
    const dadLeg = this.$el.querySelector('.dad-leg')
    const dadTail = this.$el.querySelector('.dad-tail')
    const dadEar = this.$el.querySelector('.dad-ear')
    const cubEar = this.$el.querySelector('.cub-ear')
    const cubHead = this.$el.querySelector('.cub-head')
    const cubArm = this.$el.querySelectorAll('.cub-arm')
    const bgContainer = this.$el.querySelector('.bg-container')
    const bush1 = this.$el.querySelector('.bush-1')
    const bush2 = this.$el.querySelector('.bush-2')
    const leaves1 = this.$el.querySelector('.plants-grp-1')
    const leaves2 = this.$el.querySelectorAll('.leaf-rotate')
    const bloom = this.$el.querySelectorAll('.circs circle')
    const twigs1 = this.$el.querySelector('.plants-grp-2')
    const twigs2 = this.$el.querySelector('.plants-grp-3')
    const nameTag1 = this.$el.querySelector('.father-name-tag-1')
    const nameTag2 = this.$el.querySelector('.father-name-tag-2')
    const nameTag3 = this.$el.querySelector('.father-name-tag-3')
    const star = this.$el.querySelectorAll('.father-name-star')

    this.tlBloom.from(bloom, 0.6, { scale: 0, transformOrigin: '50% 50%', yoyo: true, repeat: 1, repeatDelay: 0.2 })

    this.tlEyes
      .add('dadBrow', 0)
      .to(dadBrow1, 0.8, { rotation: 5, xPercent: 10, yPercent: 10, yoyo: true, repeat: 1 }, 'dadBrow')
      .to(dadBrow2, 0.8, { rotation: -8, xPercent: -5, yPercent: 15, yoyo: true, repeat: 1 }, 'dadBrow')
      .fromTo(dadEyelids, 0.35, { xPercent: 80, yPercent: 100 }, {
        xPercent: 0,
        yPercent: 0,
        scale: 1.1,
        yoyo: true,
        repeat: 1
      }, 'dadBrow+=0.2')
      .add('cubBrow', 0.8)
      .to(cubBrow1, 0.5, { rotation: 5, xPercent: 10, yPercent: 15, yoyo: true, repeat: 1 }, 'cubBrow')
      .to(cubBrow2, 0.5, { rotation: -8, xPercent: -5, yPercent: 25, yoyo: true, repeat: 1 }, 'cubBrow')
      .to(cubEyes, 0.25, {
        transformOrigin: '50% 50%',
        scaleX: 1.1,
        scaleY: 0,
        yoyo: true,
        repeat: 1,
        repeatDelay: 0.1
      }, 'cubBrow+=0.2')
      .to(dadMouth, 0.65, {
        transformOrigin: '50% 90%',
        scaleY: 0.8,
        yoyo: true,
        repeat: 1,
        repeatDelay: 0.2,
        ease: Power0.easeNone
      }, 1)

    this.tl
      .delay(1)
      .to(bgContainer, 2, { xPercent: -32, ease: Power1.easeInOut })
      .add('copyIn', 0.3)
      .staggerFrom(headingLines, 3, { yPercent: 300, ease: Power4.easeInOut }, 0.15, 'copyIn')
      .staggerFrom(headingSplit1.words, 1, { yPercent: 400 }, 0.03, 'copyIn+=1.3')
      .staggerFrom(headingSplit2.chars, 1, { yPercent: 100 }, 0.03, 'copyIn+=1.5')
      .from(heart, 0.7, { scale: 0, ease: Back.easeOut, transformOrigin: '50% 100%' }, 'copyIn+=2.5')
      .add('namesIn', 'copyIn+=3')
      .from(nameTag3, 0.7, { scale: 0, ease: Back.easeOut, transformOrigin: '50% 0%' }, 'namesIn')
      .from(nameTag2, 0.7, { scale: 0, ease: Back.easeOut, transformOrigin: '59% 0%' }, 'namesIn+=0.1')
      .from(nameTag1, 0.7, { scale: 0, ease: Back.easeOut, transformOrigin: '45% 0%' }, 'namesIn+=0.2')
      .staggerFrom(star, 0.9, {
        scale: 0,
        rotation: 180,
        transformOrigin: '50% 50%',
        ease: Power4.easeOut
      }, 0.1, 'namesIn')
      .add('bearSway', 2)
      .add(this.tlBloom, 'bearSway+=0.8')
      .add(this.tlEyes, 'bearSway+=0.3')
      .to(cubArm, 0.5, {
        rotation: -4,
        transformOrigin: '70% 0%',
        yoyo: true,
        repeat: -1,
        repeatDelay: 0.08,
        ease: Power0.easeNone
      }, 'bearSway')
      .from(dadArm1, 1, {
        rotation: 3,
        transformOrigin: '90% 100%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(dadArm2, 1, {
        rotation: -2,
        transformOrigin: '30% 80%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(dadLeg, 1, {
        rotation: 1,
        transformOrigin: '100% 80%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(dadTail, 1, {
        rotation: -18,
        transformOrigin: '30% 50%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(dadEar, 1, {
        rotation: 12,
        transformOrigin: '80% 50%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(cubEar, 1, {
        rotation: -12,
        transformOrigin: '80% 70%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(cubHead, 1, {
        rotation: -5,
        transformOrigin: '50% 70%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(dadCub, 1, {
        rotation: -1.2,
        transformOrigin: '50% 97%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(bush1, 1, {
        skewX: -2,
        transformOrigin: '50% 100%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(leaves1, 1, {
        rotation: 1.8,
        transformOrigin: '50% 50%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(bush2, 1, {
        skewX: 2,
        transformOrigin: '50% 100%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(leaves2, 1, {
        rotation: -18,
        transformOrigin: '50% 50%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(twigs1, 1, {
        rotation: -5,
        transformOrigin: '100% 90%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
      .to(twigs2, 1, {
        rotation: -5,
        transformOrigin: '50% 90%',
        yoyo: true,
        repeat: -1,
        ease: Power0.easeNone
      }, 'bearSway')
  },

  watch: {
    '$store.state.activeSlide' (newValue, oldValue) {
      const fatherNameText = this.$el.querySelectorAll('.father-name-text')
      TweenMax.staggerFrom(fatherNameText, 1, { scale: 0, ease: Back.easeOut, transformOrigin: '50% 50%' }, 0.1)
    }
  },

  beforeDestroy () {
    this.tl.kill()
    this.tlEyes.kill()
    this.tlBloom.kill()
  }
}
</script>

<style scoped>
  .labour-love {
    position: absolute;
    height: auto;
    width: 5.7vw;
    left: 2vw;
    bottom: 2vw;
    z-index: 5;
  }

  .bg-container {
    background: #fffdf6;
    width: 150vw;
    height: 100vh;
    position: relative;
  }

  .grass-svg,
  .bushes-svg,
  .father-cub-svg,
  .father-names {
    width: 100vw;
    height: auto;
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .heart {
    position: absolute;
    width: auto;
    height: 0.83em;
    left: 5.55em;
    top: 0.15em;
  }

  .heading {
    font-family: 'Barlow', sans-serif;
    font-size: 4.8vw;
    color: #59bec9;
    text-align: center;
    line-height: 1.1;
    overflow: hidden;
    position: absolute;
    width: 60vw;
    left: 1.8vw;
    top: 9vh;
  }

  .heading-line-1,
  .heading-line-3 {
    font-weight: 500;
    overflow: hidden;
    display: block;
  }

  .heading-line-2 {
    font-weight: 300;
    font-size: 0.75em;
  }

  .heading-line-3 {
    margin-top: 0.1em;
    position: relative;
  }

  .spacer {
    display: inline-block;
    width: 0.8em;
  }

</style>



// WEBPACK FOOTER //
// src/components/FathersSlide.vue